<script setup lang="ts">
// Plan 2026-10-04 Task 3: GGE top strip, moved out of GgeSignalTab.vue.
// GgeClMiniChart self-polls, so `ctx` is accepted (uniform strip contract)
// and ignored.
import GgeClMiniChart from '../GgeClMiniChart.vue'
import type { SignalTabCtx } from '../nav/fundPages'
defineProps<{ ctx: SignalTabCtx }>()
</script>
<template><GgeClMiniChart /></template>
